export interface ProcessStep {
  icon: string;
  title: string;
  description: string;
}

export interface ProcessSectionProps {
  title: string;
  subtitle?: string;
  steps: ProcessStep[];
}

export default function ProcessSection({ title, subtitle, steps }: ProcessSectionProps) {
  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-bronze text-xs font-medium uppercase tracking-widest mb-3">How It Works</p>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold text-charcoal mb-4">{title}</h2>
          {subtitle && <p className="text-gray-500 max-w-xl mx-auto">{subtitle}</p>}
          <div className="w-16 h-0.5 bg-bronze mx-auto mt-6"></div>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-14 left-[calc(100%/12)] right-[calc(100%/12)] h-px bg-bronze/20 z-0"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
            {steps.map((step, i) => (
              <div
                key={i}
                className="relative bg-ivory rounded-2xl p-6 text-center hover:-translate-y-2 transition-transform duration-300 z-10"
              >
                {/* Step number bg */}
                <span className="absolute top-3 right-4 font-serif text-6xl font-bold text-bronze/10 select-none leading-none">
                  {String(i + 1).padStart(2, '0')}
                </span>

                <div className="w-14 h-14 flex items-center justify-center bg-bronze/10 rounded-full mx-auto mb-4 relative z-10">
                  <i className={`${step.icon} text-bronze text-2xl`}></i>
                </div>
                <h3 className="font-serif text-base font-semibold text-charcoal mb-2">{step.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
